module.exports = __webpack_public_path__ + "static/img/lang-zh-cn.110a33d1.svg";